angular.module('dnecom')
    .filter('urlString', function () {
        return function (text) {
            return text ? String(text).replace(/[^a-zA-Z0-9-_]/g, '') : '';
        };
    });

